export default __webpack_public_path__ + "static/media/216.357e2770.png";